export default [
    {
        path: "/",
        name: "index",
        component: () => import('@/views/modules/Landing'),
        meta: {
          layout: 'base',
        }
    },
    {
        path: "/register",
        name: "register",
        component: () => import('@/views/modules/Register'),
        meta: {
          layout: 'base',
        }
    },

    {
        path: "/legal",
        name: "legal",
        component: () => import('@/views/modules/Legal'),
        meta: {
          layout: 'base',
        }
    },


    {
        path: "/home",
        name: "home",
        component: () => import('@/views/modules/Home'),
        meta: {
          requiresAuth:true,
          layout: 'app',
          title: 'Home',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Dashboard' }
          ]
        }
    },
    {
        path: "/support",
        name: "support",
        component: () => import("@/views/Support"),
        meta: {
            layout: "base"
        }
    },
  
    {
        path: "/update",
        name: "update",
        component: () => import("@/views/Update"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "*",
        name: "404",
        component: () => import("@/views/Error"),
        meta: {
            layout: "base"
        }
    }
];
